/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */
import { DecisionPoint } from './decision.point';
import { Track }         from './track';
import { Train  }        from './train';
import { WorkBlock  }    from './work.block';

export enum DiversionType {
  NONE         = 0,
  OneWay       = 1
}

/**
 *
 * @class Diversion
 *
 * @brief base model for one way train diversions
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class Diversion {

  /** @var number the unique id of this diversion */
  public             _id: number              = -1;

  /** @var string user label for diversion */
  public            _name: string             = '';

  /** @var string user description for diversion */
  public     _description: string             = '';

  /** @var DecisionPoint|null the decision point on west side of work */
  public            _from: DecisionPoint|null = null;

  /** @var Track|null the link to use on west side */
  public       _fromTrack: Track|null         = null;

  /** @var DecisionPoint|null the decision point on east side of work */
  public              _to: DecisionPoint|null = null;

  /** @var Track|null the link to use on east side */
  public         _toTrack: Track|null         = null;

  /** @var Train[] the trains that are in this diversion group */
  public          _trains: Train[]            = [];

  /** @var number the seconds amount of work (within a day) */
  public        _duration: number             = 0;

  /** @var number deviation to apply to duration */
  public          _stddev: number             = 0;

  /** @var WorkBlock|null workblock this diversion is for */
  public            _work: WorkBlock|null    = null;

  /** @var DiversionType the kind of diversion */
  public            _type: DiversionType     = DiversionType.OneWay;

  /** @var number zero based index for this item */
  public             _nth: number            = -1;

  /** @brief standard constructor */
  constructor(      id: number,
                  from: DecisionPoint|null,
             fromTrack: Track|null,
                    to: DecisionPoint|null,
               toTrack: Track|null,
                trains: Train[],
              duration: number,
                stddev: number,
                  type: DiversionType,
                  work: WorkBlock|null,
                  name: string,
           description: string,
                   nth: number) {

    this._id          = id;
    this._from        = from;
    this._fromTrack   = fromTrack;
    this._to          = to;
    this._toTrack     = toTrack;
    this._trains      = trains;
    this._duration    = duration;
    this._stddev      = stddev;
    this._type        = type;
    this._work        = work;
    this._name        = name;
    this._description = description;
    this._nth         = nth;
  }

  /** @brief convert diversion type to a string */
  public static typeToString(type: DiversionType): string {

    switch (type) {
      case DiversionType.NONE:      return 'N';
      case DiversionType.OneWay:    return 'O';
    }

    return '';
  }

  /** @brief convert diversion string to a type */
  public static typeFromString(type: string): DiversionType {

    const tmp: string = type.toLowerCase().trim();

    if ((tmp === 'n') || (tmp === '')) {

      return DiversionType.NONE;

    } else if ((tmp === 'o') || (tmp === 'oneway')) {

      return DiversionType.OneWay;

    }

    return DiversionType.NONE;
  }

}
